export const getServicesData = state => state.servicesData;
export const getServices = state => getServicesData(state).services || [];
export const accountHasAnIntegration = state => getServices(state)
  .some(service => service.integrations.length > 0);
export const getServiceWithoutIntegration = state => getServices(state)
  .find(service => service.integrations.length === 0) || {};
export const getFirstService = state => getServices(state)[0] || {};

export default getServicesData;
